





















































import {Vue, Component} from 'vue-property-decorator';
import {DisplayEnum} from '@/types/enum';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {toI18n} from '@/utils/commonUtils';
import {ProductsSaleSettingStatusType} from 'supporter';

@Component({
  components: {
    PageFormSelect
  }
})
export default class ModifySaleStatus extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private currentStatusType: string = 'NONE';
  private tempStatusType: string = 'NONE';
  private get mallProductNos() {
    return this.$route.params.mallProductNos.split(',');
  }
  private saleSettingStatusType: DisplayEnum[] = [
    {value: 'NONE', label: this.toI18n('CHANGE_OF_SALES_STATUS')}, //판매상태 변경
    {value: 'AVAILABLE_FOR_SALE', label: this.toI18n('ON_SALEORON_RESERVATION_SALE')}, //판매가능
    {value: 'STOP_SELLING', label: this.toI18n('STOP_SELLING')}, //판매중지
    {value: 'PROHIBITION_SALE', label: this.toI18n('PROHIBITION_OF_SALE')} //판매금지
  ];

  private onChangeSaleStatusType(val: string) {
    if (val === 'PROHIBITION_SALE') {
      if (!confirm(this.toI18n('IF_YOU_CHANGE_TO_PROHIBITION_OF_SALES'))) {
        //판매금지로 변경 할 경우 판매재개가 불가능합니다. 판매금지로 변경하시겠습니까?
        this.$nextTick(() => {
          this.currentStatusType = this.tempStatusType;
        });
      } else {
        this.tempStatusType = val;
      }
    } else {
      this.tempStatusType = val;
    }
  }

  private save() {
    if (this.currentStatusType === 'NONE') {
      alert(this.toI18n('PLEASE_ENTER_A_VALUE')); //값을 입력해주세요
      return;
    }

    const mallProductNos = this.mallProductNos;
    const saleSettingStatusType = this.currentStatusType as ProductsSaleSettingStatusType;
    const data = {
      saleSettingStatusType
    };
    if (this.currentStatusType === 'PROHIBITION_SALE') {
      this.$api
        .putProductsFrontdisplay({
          data: {
            frontDisplayYn: 'N',
            productNos: mallProductNos
          }
        })
        .then(({data: fData}: any): void => {
          if (fData.failures && fData.failures.length) {
            return alert(fData.failures[0].message);
          }

          this.$api
            .putProductsSaleStatus({
              data: {
                ...data,
                productNos: mallProductNos
              }
            })
            .then(({data}: any): void => {
              window.opener.postMessage({modifySaleStatus: true, data});
              this.close();
            });
        });
    } else {
      this.$api
        .putProductsSaleStatus({
          data: {
            ...data,
            productNos: mallProductNos
          }
        })
        .then(({data}: any): void => {
          // console.log('%c 🌮 data: ', 'font-size:20px;background-color: #FCA650;color:#fff;', data);
          // if (data.failures && data.failures.length) {
          //   return alert(data.failures[0].message);
          // }
          window.opener.postMessage({modifySaleStatus: true, data});
          this.close();
        });
    }
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup', 'popup_medium');
    window.name = 'saleStatus';
  }
}
